export default "__VITE_ASSET__47f4499a__"